import { ReactNode } from 'react';

interface Props {
  render: ReactNode;
}

const RenderNode = ({ render }: Props) => {
  return (
    <div className="node">
      {render}
    </div>
  );
};

export default RenderNode;
